export default __webpack_public_path__ + "1.17.15/static/media/close.b1d40998.svg";